import { activateElInViewport } from '../../scripts/utils/activateElInViewport';

const initPageMobileAnimation = () => {
  const animatedImages = document.querySelectorAll('[data-animated-images]');

  animatedImages.forEach((animatedImage) => {
    activateElInViewport(animatedImage, 'data-start-animation');
  });
};

initPageMobileAnimation();
